import { Empty } from 'fave-ui';

const NoDataFound = () => (
  <Empty emptyType={'nothing-here'} customDescription="No data found" />
);

export default NoDataFound;
